import { useState } from "react";

let stateMap: Record<string, any>;
export const usePermanentState = <T,>(uid: string, initial: T):[T, React.Dispatch<React.SetStateAction<T>>]=>{
    if (!stateMap){
        stateMap = {};
    }
    const [state, setState] = useState<T>((stateMap[uid] as T) ?? initial);
    return [state, (setter: React.SetStateAction<T>)=>{
        stateMap[uid] = (setter instanceof Function) && setter ? setter(stateMap[uid] ?? initial) : setter;
        setState(setter);
    }];
}